/**
 * コメント候補テンプレート一覧を保存する。
 * 管理シートのドラフト全体を受け取り、既存データを置き換える。
 */

import { commentCandidateTable } from '../../schema'
import type {
  DatabaseWithTransaction,
  InsertCommentCandidateData,
} from '../../types'

/**
 * コメント候補テンプレート一覧を保存する。
 * @param params DB 接続と保存対象一覧を受け取る。
 * @returns 値は返さない。
 */
export const saveCommentCandidates = async ({
  candidates,
  database: { transaction },
}: {
  readonly database: DatabaseWithTransaction
  readonly candidates: readonly InsertCommentCandidateData[]
}): Promise<void> => {
  await transaction([
    (tx) => [tx.delete(commentCandidateTable)],
    (tx) => {
      if (candidates.length === 0) {
        return []
      }

      return [
        tx.insert(commentCandidateTable).values(
          candidates.map((candidate, index) => ({
            id: candidate.id,
            displayOrder: index + 1,
            parts: candidate.parts,
          })),
        ),
      ]
    },
  ])
}
